import styled from 'styled-components';
import { media } from '@pik/pik-ui';

export const Container = styled.div`
  padding: 32px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #E6E6E6;
  
  &:first-child {
    margin-top: -32px;
  }
  
  @media ${media.max768} {
   padding: 15px 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const HeaderInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 49px 165px 4px 142px;
  
  @media ${media.max768} {
   padding: 41px 0 10px 0;
  }
`;

export const ContentWrapper = styled.div`
  overflow: hidden;
  will-change: height;
  transition: height .3s ease;
  backface-visibility: hidden;
  height: ${({ height }) => `${height}px`}
`;

export const ContentItemWrapper = styled.div`
  margin-bottom: 24px;
`;

export const Image = styled.img`
  display: block;
  width: 96px;
  height: 96px;
  border-radius: 8px;
  margin-right: 32px;
  
  @media ${media.max768} {
    width: 78px;
    height: 78px;
    margin-right: 17px;
  }
`;

export const Title = styled.span`
  display: block;
  font-family: Graphik;
  font-weight: 500;
  color: #222222;
  margin-bottom: 8px;
  font-size: ${({ content }) => (content ? '14px' : '20px')};
  line-height: ${({ content }) => (content ? '24px' : '21px')};  
  
  @media ${media.max768} {
    ${({ content }) => !content && `
      font-size: 20px;
      line-height: 28px;
   `};
  }
`;

export const MainInfo = styled.span`
  display: block;
  font-size: 16px;
  line-height: 24px;
  color: #808080;
  
  @media ${media.max768} {

  }
`;

export const Text = styled.span`
  display: block;
  font-size: 15px;
  line-height: 24px;
  color: ${({ content }) => (content ? '#222222' : '#4D4D4D')};
  ${({ content }) => (content && 'margin-bottom: 16px;')};
  
  @media ${media.max768} {
    font-size: 13px;
    line-height: 17px;
  }
`;

export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform .3s ease;
  
  path {
    transition: stroke .3s ease;
  }
  
  &:hover {
    path {
      stroke: #222222;
    }
  }    
  
  ${({ active }) => (active && `
    transform: rotate(180deg);
    
    path {
      stroke: #222222;
    }
  `)};
`;
